const teaching = {
  state: {
    toolResourceFileActive: 'standardCourseWare',
    toolItemZIndex: {
      timer: 99, // 层级固定不变
      randomQuestion: 98, // 层级固定不变
    },
    isFullScreen: false,
    imgList: [], // 班辅同屏比较预览用的imList，暂时放这
    isPreview: false,

    isMultiPhotoPreview: false, // 多图片同时预览的时候需要控制弹窗的移动
    chapter: {}, // 当前章节

    taskPanelFull: false, // 任务弹窗面板全屏
    qrzRankFull: false, // 全日制积分排行榜全屏
  },

  mutations: {
    SET_ACTIVE: (state, name) => {
      state.toolResourceFileActive = name
    },
    SET_Z_INDEX: (state, name) => {
      const delItem = ['timer', 'randomQuestion'] // 不参与层级计算
      if (delItem.includes(name)) {
        return
      }
      const {toolItemZIndex} = state
      let keys = Object.keys(toolItemZIndex).filter(o => !delItem.includes(o))
      console.log('keys==', keys, toolItemZIndex)
      let values = keys.map(k => toolItemZIndex[k])
      console.log('values==', values, toolItemZIndex)
      values.sort((a, b) => b-a)
      let max = values[0] || 0
      if (toolItemZIndex[name] && toolItemZIndex[name] == max) {
        return
      }
      toolItemZIndex[name] = max + 1
      state.toolItemZIndex = {...toolItemZIndex}
    },
    SET_IS_FULL_SCREEN:(state, isFullScreen) => {
      state.isFullScreen = isFullScreen
    },
    SET_IMG_LIST: (state, imgList) => {
      state.imgList = [...imgList]
    },
    SET_IS_PREVIEW: (state, isPreview) => {
      state.isPreview = isPreview
    },
    SET_IS_MULTI_PHOTO_PREVIEW: (state, isMultiPhotoPreview) => {
      state.isMultiPhotoPreview = isMultiPhotoPreview
    },
    SET_CHAPTER: (state, chapter) => {
      state.chapter = chapter
    },
    SET_TASK_PANEL_FULL: (state, taskPanelFull) => {
      state.taskPanelFull = taskPanelFull
    },
    SET_QRZ_RANK_FULL: (state, qrzRankFull) => {
      state.qrzRankFull = qrzRankFull
    },
  },
  actions: {
    setToolCurrentActive({commit}, data) {
      commit('SET_ACTIVE', data)
    },
    setToolItemZIndex({commit}, data) {
      commit('SET_Z_INDEX', data)
    },
    setIsFullScreen({commit}, data) {
      commit('SET_IS_FULL_SCREEN', data)
    },
    setImgList({commit}, data) {
      commit('SET_IMG_LIST', data)
    },
    setIsPreview({commit}, data) {
      commit('SET_IS_PREVIEW', data)
    },
    setIsMultiPhotoPreview({commit}, data) {
      commit('SET_IS_MULTI_PHOTO_PREVIEW', data)
    },
    setChapter({commit}, data) {
      commit('SET_CHAPTER', data)
    },
    setTaskPanelFull({commit}, data) {
      commit('SET_TASK_PANEL_FULL', data)
    },
    setQrzRankFull({commit}, data) {
      commit('SET_QRZ_RANK_FULL', data)
    },

  }
}
export default teaching